
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigResponse} from './ConfigResponse';
import {FieldModelConfigResponse} from './ConfigResponse';
import {TradingCalendarRegularRule} from '../core/TradingCalendarRegularRule';
import {FieldModelTradingCalendarRegularRule} from '../core/TradingCalendarRegularRule';

/**
 * TradingCalendarRegularRuleGetResponse struct
 */
class TradingCalendarRegularRuleGetResponse extends ConfigResponse {
  /**
   * Initialize struct
   * @param {!ConfigResponse=} parent
   * @param {UUID=} symbolId
   * @param {string=} symbolName
   * @param {!TradingCalendarRegularRule=} tradingCalendarRegularRule
   * @constructor
   */
  constructor (parent = new ConfigResponse(), symbolId = null, symbolName = null, tradingCalendarRegularRule = new TradingCalendarRegularRule()) {
    super()
    super.copy(parent)
    this.SymbolId = symbolId
    this.SymbolName = symbolName
    this.TradingCalendarRegularRule = tradingCalendarRegularRule
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradingCalendarRegularRuleGetResponse}
   * @param {!TradingCalendarRegularRuleGetResponse} other Other struct
   * @returns {!TradingCalendarRegularRuleGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SymbolId != null) {
      this.SymbolId = new UUID(other.SymbolId)
    } else {
      this.SymbolId = null
    }
    if (other.SymbolName != null) {
      this.SymbolName = other.SymbolName
    } else {
      this.SymbolName = null
    }
    if (other.TradingCalendarRegularRule != null) {
      this.TradingCalendarRegularRule = TradingCalendarRegularRule.fromObject(other.TradingCalendarRegularRule)
    } else {
      this.TradingCalendarRegularRule = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradingCalendarRegularRuleGetResponse}
   * @returns {!TradingCalendarRegularRuleGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradingCalendarRegularRuleGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradingCalendarRegularRuleGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradingCalendarRegularRuleGetResponse}
   * @param {!TradingCalendarRegularRuleGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingCalendarRegularRuleGetResponse)) {
      throw new TypeError('Instance of TradingCalendarRegularRuleGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradingCalendarRegularRuleGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SymbolId: ((this.SymbolId != null) ? this.SymbolId.toString() : null),
      SymbolName: ((this.SymbolName != null) ? this.SymbolName : null),
      TradingCalendarRegularRule: ((this.TradingCalendarRegularRule != null) ? this.TradingCalendarRegularRule : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradingCalendarRegularRuleGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradingCalendarRegularRuleGetResponse} other Object value
   * @returns {!TradingCalendarRegularRuleGetResponse} Created struct
   */
  static fromObject (other) {
    return new TradingCalendarRegularRuleGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradingCalendarRegularRuleGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradingCalendarRegularRuleGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradingCalendarRegularRuleGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6283
  }
}

export { TradingCalendarRegularRuleGetResponse };

/**
 * Fast Binary Encoding TradingCalendarRegularRuleGetResponse field model
 */
class FieldModelTradingCalendarRegularRuleGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigResponse(buffer, 4 + 4)
    this.SymbolId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.SymbolName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.SymbolId.fbeOffset + this.SymbolId.fbeSize), buffer, this.SymbolId.fbeOffset + this.SymbolId.fbeSize)
    this.TradingCalendarRegularRule = new FieldModelTradingCalendarRegularRule(buffer, this.SymbolName.fbeOffset + this.SymbolName.fbeSize)
  }

  /**
   * Get the ConfigResponse field model
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @returns {!FieldModelConfigResponse} ConfigResponse field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SymbolId.fbeSize + this.SymbolName.fbeSize + this.TradingCalendarRegularRule.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SymbolId.fbeExtra + this.SymbolName.fbeExtra + this.TradingCalendarRegularRule.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradingCalendarRegularRuleGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6283
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolId.fbeSize

    if ((fbeCurrentSize + this.SymbolName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolName.fbeSize

    if ((fbeCurrentSize + this.TradingCalendarRegularRule.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradingCalendarRegularRule.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradingCalendarRegularRule.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @param {!TradingCalendarRegularRuleGetResponse} fbeValue Default value, defaults is new TradingCalendarRegularRuleGetResponse()
   * @returns {!TradingCalendarRegularRuleGetResponse} TradingCalendarRegularRuleGetResponse value
   */
  get (fbeValue = new TradingCalendarRegularRuleGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @param {!TradingCalendarRegularRuleGetResponse} fbeValue TradingCalendarRegularRuleGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolId.fbeSize) <= fbeStructSize) {
      fbeValue.SymbolId = this.SymbolId.get()
    } else {
      fbeValue.SymbolId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolId.fbeSize

    if ((fbeCurrentSize + this.SymbolName.fbeSize) <= fbeStructSize) {
      fbeValue.SymbolName = this.SymbolName.get()
    } else {
      fbeValue.SymbolName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolName.fbeSize

    if ((fbeCurrentSize + this.TradingCalendarRegularRule.fbeSize) <= fbeStructSize) {
      fbeValue.TradingCalendarRegularRule = this.TradingCalendarRegularRule.get()
    } else {
      fbeValue.TradingCalendarRegularRule = new TradingCalendarRegularRule()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradingCalendarRegularRule.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @param {!TradingCalendarRegularRuleGetResponse} fbeValue TradingCalendarRegularRuleGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradingCalendarRegularRuleGetResponse}
   * @param {TradingCalendarRegularRuleGetResponse} fbeValue TradingCalendarRegularRuleGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SymbolId.set(fbeValue.SymbolId)
    this.SymbolName.set(fbeValue.SymbolName)
    this.TradingCalendarRegularRule.set(fbeValue.TradingCalendarRegularRule)
  }
}

export { FieldModelTradingCalendarRegularRuleGetResponse };

/**
 * Fast Binary Encoding TradingCalendarRegularRuleGetResponse model
 */
class TradingCalendarRegularRuleGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradingCalendarRegularRuleGetResponse(this.buffer, 4)
  }

  /**
   * Get the TradingCalendarRegularRuleGetResponse model
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @returns {!FieldModelTradingCalendarRegularRuleGetResponse} model TradingCalendarRegularRuleGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradingCalendarRegularRuleGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradingCalendarRegularRuleGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @param {!TradingCalendarRegularRuleGetResponse} value TradingCalendarRegularRuleGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @param {!TradingCalendarRegularRuleGetResponse} value TradingCalendarRegularRuleGetResponse value, defaults is new TradingCalendarRegularRuleGetResponse()
   * @return {!object} Deserialized TradingCalendarRegularRuleGetResponse value and its size
   */
  deserialize (value = new TradingCalendarRegularRuleGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradingCalendarRegularRuleGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradingCalendarRegularRuleGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradingCalendarRegularRuleGetResponseModel}
   * @param {!number} prev Previous TradingCalendarRegularRuleGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradingCalendarRegularRuleGetResponseModel };
